export default {
  DEFAULT_ICON_COLOR: 'rgb(255,255,255)',
  DEFAULT_ICON_WIDTH: '100%',
  DEFAULT_ICON_HEIGHT: '100%',
};
